import * as React from 'react';
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import StarIcon from '@mui/icons-material/Star';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useContext } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import { useEffect } from 'react';
import { useState } from 'react';
import Swal from "sweetalert2"
import { DateFormaterMonth } from '../../Utils/GlobalFunction';

const ProductDetailsInfo = ({ shortDescription }) => {
    const navigate = useNavigate();
    const { apiURL, customer_id, apiHeaderJson } = useContext(ConfigContext)
    const headers = apiHeaderJson
    let token = localStorage.getItem("token");
    const labels = {
        1: 'Useless+',
        2: 'Poor+',
        3: 'Ok+',
        4: 'Good+',
        5: 'Excellent+',
    };

    function getLabelText(value) {
        return `${value} Star${value !== 1 ? 's' : ''}, ${labels[value]}`;
    }

    const [value, setValue] = React.useState(5);
    const [hover, setHover] = React.useState(-1);
    const path = useLocation();
    const product_id = path.pathname.split('=')[1];
    const [ratings, setRatings] = useState([]);
    const [averageRating, setAverageRating] = useState(0);
    const [customerReview, setCustomerReview] = useState([]);
    const [formData, setFormData] = useState({ name: "", email: "", description: "", contactNumber: "" });
    const [errors, setErrors] = useState({});

    const handleCheckLogin = () => {
        if (!token) {
            navigate("/Login")
        }
    }

    const resetForm = () => {
        setFormData({
            name: "",
            email: "",
            description: "",
            contactNumber: "",
        })
    }

    const validation = () => {
        let newErrors = {}

        if (!formData.name) {
            newErrors.name = "Name is required";
        }

        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }

        if (!formData.description) {
            newErrors.description = "Description is required";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validation()) return;

        const body = {
            customer_name: formData.name,
            customer_email: formData.email,
            product_id,
            review_text: formData.description,
            review_rating: value
        };

        try {
            const response = await axios.post(
                `${apiURL}Customers/SubmitCustomerReview`,
                body,
                { headers }
            );

            const { success, message } = response.data;

            Swal.fire({
                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                text: message,
                icon: success ? "success" : "error",
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
            });

            if (success) {
                resetForm();
                GetReviews();
            }
        } catch (error) {
            console.log(error);
        }
    };

    const calculateRating = (data) => {
        const ratingCounts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
        let totalSum = 0;

        data.forEach(item => {
            const rate = parseInt(item.review_rating, 10);
            if (!isNaN(rate) && rate >= 1 && rate <= 5) {
                ratingCounts[rate]++;
                totalSum += rate;
            }
        });

        const totalRatings = data.length;
        const avg = totalRatings === 0 ? 0 : (totalSum / totalRatings).toFixed(1);

        const ratingsArray = Object.keys(ratingCounts).map(rate => ({
            rate: Number(rate),
            count: ratingCounts[rate],
            percentage: totalRatings === 0 ? 0 : ((ratingCounts[rate] / totalRatings) * 100).toFixed(0)
        }));

        return { ratingsArray, avg };
    };

    const GetReviews = async () => {
        try {
            const response = await axios.get(`${apiURL}Customers/GetCustomerReviews`, { params: { product_id } });

            const { success, data } = response.data;

            if (success) {
                setCustomerReview(data);
                const result = calculateRating(data);
                setRatings(result.ratingsArray);
                setAverageRating(result.avg);
            }
        } catch (error) {
            console.error("Error fetching reviews:", error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target

        setFormData({
            ...formData, [name]: value
        })

        setErrors((prevErrors) => ({
            ...prevErrors, [name]: null
        }))
    }

    const GetInfo = async () => {
        try {
            const response = await axios.get(`${apiURL}Customers/GetCustomerInfo`, {
                headers
            })
            const data = response.data

            if (response.data.success === true) {
                setFormData({
                    name: data.data[0]?.customer_name,
                    email: data.data[0]?.customer_email,
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    const Data = async () => {
        const response = await axios.get(`${apiURL}Customers/GetCustomerInfo`, {
            headers
        })
    }

    useEffect(() => {
        if (customer_id) {
            Data()
        }
        GetInfo();
        GetReviews();
    }, [customer_id])

    return (
        <div className="container-fluid px-0">
            <div className="tab-style3 border rounded-3">
                <ul className="nav nav-tabs text-uppercase p-3">
                    <li className="nav-item">
                        <a className="nav-link active" id="Description-tab" data-bs-toggle="tab" href="#Description">Description</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" id="Reviews-tab" data-bs-toggle="tab" href="#Reviews">Reviews ({customerReview.length})</a>
                    </li>
                </ul>

                <div className="tab-content entry-main-content p-3">
                    <div className="tab-pane fade show active" id="Description">
                        <p className="mb-0">{shortDescription}</p>
                    </div>

                    <div className="tab-pane fade" id="Reviews">
                        <div className="comments-area mt-0">
                            <div className="row g-4">
                                <div className="col-lg-8">
                                    <h4 className="mb-4">Customer questions & answers</h4>
                                    {customerReview?.length > 0 ? (
                                        customerReview?.map((review) => (
                                            <div className="comment-list mb-4" key={review.id}>
                                                <div className="single-comment justify-content-between d-flex">
                                                    <div className="user justify-content-between d-flex">
                                                        <div className="thumb text-center me-3">
                                                            <img src="/assets/imgs/blog/author-2.png" alt="User" className="img-fluid" />
                                                            <a href="#" className="font-heading text-brand d-block mt-2">{review?.customer_name}</a>
                                                        </div>
                                                        <div className="desc">
                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                <span className="font-xs text-muted me-2">{DateFormaterMonth(review?.created_date)}</span>
                                                                <div className="product-rate d-inline-block">
                                                                    <div
                                                                        className="product-rating"
                                                                        style={{ width: `${(review?.review_rating / 5) * 100}%` }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <p className="mb-0">{review?.review_text}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p>No reviews yet.</p>
                                    )}
                                </div>

                                <div className="col-lg-4">
                                    <div className="border p-3 rounded">
                                        <h4 className="mb-3">Customer reviews</h4>
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="product-rate d-inline-block me-2">
                                                <div className="product-rating" style={{ width: `${(averageRating / 5) * 100}%` }} />
                                            </div>
                                            <h5 className="mb-0">{averageRating} out of 5</h5>
                                        </div>

                                        {ratings.sort((a, b) => b.rate - a.rate).map(item => (
                                            <div className="mb-2" key={item.rate}>
                                                <div className="d-flex justify-content-between mb-1">
                                                    <span>{item.rate} star</span>
                                                    <span>{item.percentage}%</span>
                                                </div>
                                                <div className="progress" style={{ height: "8px" }}>
                                                    <div
                                                        className="progress-bar bg-warning"
                                                        role="progressbar"
                                                        style={{ width: `${item.percentage}%` }}
                                                        aria-valuenow={item.percentage}
                                                        aria-valuemin={0}
                                                        aria-valuemax={100}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="comment-form mt-5">
                            <h4 className="mb-4">Add a review</h4>
                            <Box display="flex" alignItems="center" className="mb-4">
                                <Rating
                                    name="hover-feedback"
                                    value={value}
                                    precision={0.5}
                                    getLabelText={getLabelText}
                                    onChange={(event, newValue) => {
                                        setValue(newValue);
                                    }}
                                    onChangeActive={(event, newHover) => {
                                        setHover(newHover);
                                    }}
                                    icon={<StarIcon fontSize="inherit" />}
                                    emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                                />
                                {value !== null && (
                                    <Box ml={2} className="fw-bold">
                                        {hover !== -1 ? labels[hover] : labels[value]}
                                    </Box>
                                )}
                            </Box>

                            <form className="form-contact comment_form" onSubmit={handleSubmit} id="commentForm">
                                <div className="row">
                                    <div className="col-sm-6 mb-3">
                                        <div className="form-group">
                                            <input
                                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                value={formData?.name}
                                                onChange={handleInputChange}
                                                name="name"
                                                id="name"
                                                type="text"
                                                placeholder="Name"
                                            />
                                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                        </div>
                                    </div>
                                    <div className="col-sm-6 mb-3">
                                        <div className="form-group">
                                            <input
                                                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                name="email"
                                                value={formData?.email}
                                                onChange={handleInputChange}
                                                id="email"
                                                type="email"
                                                placeholder="Email"
                                            />
                                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                        </div>
                                    </div>
                                    <div className="col-12 mb-3">
                                        <div className="form-group">
                                            <textarea
                                                className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                                name="description"
                                                onChange={handleInputChange}
                                                value={formData?.description}
                                                id="comment"
                                                cols={30}
                                                rows={5}
                                                placeholder="Write description"
                                            />
                                            {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <button type="submit" onClick={handleCheckLogin} className="btn btn-dark py-2 px-4">Submit Review</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductDetailsInfo;